import styles from "./privacyAccepted.module.css";
import React from "react";

const PrivacyAgreement = ({privacyAccepted, setPrivacyAccepted}) => {
    return (
        <>
            <label className={styles.privacyPolicy}>
                <input
                    required
                    type="checkbox"
                    checked={privacyAccepted}
                    onChange={(e) => setPrivacyAccepted(e.target.checked)}
                />
                <span>
                        Нажимая кнопку “Зарегистрироваться”, Вы соглашаетесь с{' '}
                    <a target={"_blank"} rel="noopener noreferrer" href="/privacy" className={styles.link}>Политикой Конфиденциальности</a>
                    </span>
            </label>
        </>
    )
}

export default PrivacyAgreement;